import { MOCK_SCHEDULES_EN } from './locales/en/mock-schedules.js';
import { MOCK_SCHEDULES_EN_US } from './locales/en-us/mock-schedules.js';
import { MOCK_SCHEDULES_JA } from './locales/ja/mock-schedules.js';
import { MOCK_SCHEDULES_KO } from './locales/ko/mock-schedules.js';
import { MOCK_SCHEDULES_ZH_CN } from './locales/zh-cn/mock-schedules.js';
import { MOCK_SCHEDULES_ZH_TW } from './locales/zh-tw/mock-schedules.js';

/**
 * @typedef {Object} MockSchedule
 * @property {string} id
 * @property {string} nextDate
 * @property {string} transactionType
 * @property {number} estimatedAmount
 * @property {string} currencySymbol
 * @property {number} currencyDecimalPlaces
 * @property {string} displayAccount
 * @property {string} displayFreq
 * @property {string} description
 * @property {boolean} [isSchedulePair]
 * @property {string} [displaySourceAccount]
 * @property {string} [displayDestAccount]
 * @property {string} [pairedType]
 * @property {string} [pairedCurrencySymbol]
 * @property {number} [pairedCurrencyDecimalPlaces]
 */

/** @type {Record<string, Array<MockSchedule>>} */
const SCHEDULES = {
	en: MOCK_SCHEDULES_EN,
	'en-US': MOCK_SCHEDULES_EN_US,
	ja: MOCK_SCHEDULES_JA,
	ko: MOCK_SCHEDULES_KO,
	'zh-CN': MOCK_SCHEDULES_ZH_CN,
	'zh-TW': MOCK_SCHEDULES_ZH_TW,
};

/**
 * @param {string} lang
 * @returns {Array<MockSchedule>}
 */
export function getMockSchedules(lang) {
	return SCHEDULES[lang] ?? MOCK_SCHEDULES_EN;
}
